import { httpClient } from '@texas/api/httpClient/httpClient';

export interface Technique {
  id: number;
  code: string;
  value: string;
  description: string | null;
  vdcSupport: boolean;
  displayOrder: number;
  archived: boolean;
}

export interface TechniqueRequest {
  code: string;
  value: string;
  description: string;
  vdcSupport: boolean;
  displayOrder: number;
  archived: boolean;
}

interface Query {
  vdcSupport?: boolean;
}

export const techniquesApi = {
  getAll: (query?: Query) =>
    httpClient.get<Technique[]>(`organizations/3/techniques`, {
      params: query,
    }),
  getAllForOrganization: (organizationId: number, query?: Query) =>
    httpClient.get<Technique[]>(`organizations/${organizationId}/techniques`, {
      params: query,
    }),
  create: (organizationId: number, request: TechniqueRequest) =>
    httpClient.post<Technique>(`organizations/${organizationId}/techniques`, {
      data: request,
    }),
  update: (id: number, request: TechniqueRequest) =>
    httpClient.put<Technique>(`techniques/${id}`, { data: request }),
};
